import { render, staticRenderFns } from "./GoogleRecaptchaText.vue?vue&type=template&id=90f80440&"
import script from "./GoogleRecaptchaText.vue?vue&type=script&lang=js&"
export * from "./GoogleRecaptchaText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports